import { getActivePinia } from 'pinia'

export const useGetStore = () => {
	const getStore = (storeId: string) => {
		const pinia = getActivePinia()
		if (!pinia) {
			console.error('Pinia is not active.')
			return null
		}

		const store = pinia._s.get(storeId) // Access the store dynamically
		if (!store) {
			console.error(`Store with ID "${storeId}" not found.`)
		}
		return store
	}

	return {
		getStore,
	}
}
